import { FC } from "react";

const VerticalLine: FC = () => {
  return (
    <>
      <svg
        className="logo-line min-w-1px"
        width="2"
        height="50"
        viewBox="0 0 2 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="1"
          y1="4.37114e-08"
          x2="0.999998"
          y2="50"
          stroke="#AAAAAA"
          strokeWidth="2"
        />
      </svg>
    </>
  );
};

export default VerticalLine;
